import { slugToLink } from '@/utilities/slugToLink'
import { cn } from '@/utilities/ui'
import Link from 'next/link'

interface Props {
    className?: string
    slug?: string | null
    title: string
}

export function CategoryAccentLink({ slug, title, className }: Props) {
    return (
        <div
            className={cn(
                'uppercase text-base flex items-center justify-center before:border before:border-accent before:flex-grow after:border after:flex-grow after:border-accent',
                className,
            )}
        >
            <Link className='truncate bg-accent text-accent-foreground py-2 px-6 font-bold' href={slugToLink(slug)}>
                {title}
            </Link>
        </div>
    )
}
